let BTCollection = {
	selectors: {
		section: '.collection-template-section',
		filter: '.cf',
		filterContent: '.cf__content',
		filterForm: '.cf__form',
		filterLink: '.cf__link',
		filterInput: '.cf__link__input',
		filterPriceSlider: '.cf__price-slider',
		filterPriceFrom: '.cf__price-from',
		filterPriceTo: '.cf__price-to',
		filterPriceInputMin: '.cf__price-input-min',
		filterPriceInputMax: '.cf__price-input-max',
		filterCurrentInline: '.cf__current-inline',
		filterApplyBtn: '.filter-action-mobile__item--submit-btn',
		sortInput: '.cf__sort-by',
		sortLink: '.ct__sort__link',
		products: '.collection__products',
		currentTags: '.collection__current-tags',
		productsInner: '.products',
		modeLink: '.ct__mode__link',
		sort: '.ct__sort',
		total: '.ct__total',
		pagination: '.pagination',
		scrollBtn: '.collection__scroll',
		paginationButton: '.collection__scroll,.button--more,.pagination',
		productGrid: '.grid--products',
		productItem: '.grid__item',
		wrap: '#collection-template'
	},

	options: {
		clickEvent: 'click',
		ajaxView: 'ajax'
	},

	data: {
		collectionUrl: '',
		priceSlider: []
	},

	padZero: function(str, len) {
    len = len || 2;
    var zeros = new Array(len).join('0');
    return (zeros + str).slice(-len);
  },
	applyCustomColorSwatches: function(wrap) {
    wrap.find('.cf__link__box.color-load').each((index, ele) => {
    	const colorEle = $(ele);
    	const colorComponents = colorEle.css('background-color').replace('rgba(', '').replace('rgb(','').replace(')','').replace(/ /g, '')
         .split(',');
      const r = parseInt(colorComponents[0]);
      const g = parseInt(colorComponents[1]);
      const b = parseInt(colorComponents[2]);
      const newColor = (r * 0.299 + g * 0.587 + b * 0.114) > 186 ? '#000000' : '#FFFFFF';
      colorEle.css('color', newColor)
    });
  },
	updateHtml: function(html) {
		const selector = this.selectors;
		const section = $(selector.section);
		if($(selector.scrollBtn).length > 0) {
			this.destroyInfiniteScroll();
		}
		section.html($(selector.section, html).html());
		BT.reLoadReview(selector.productGrid);
		BtCurrency.convertSilence(shopCurrency, BtCurrency.currentCurrency, $(selector.wrap).find('span.money'));
		BT.initDealCountdown(selector.products);
		BT.popularAddedWishlistItems(selector.products);
		this.updateTotalValuesNumber();
		this.applyCustomColorSwatches(section);
    // Remove old current inline

		if(section.offset().top < $(window).scrollTop()) {
			$('html, body').animate({
        scrollTop: (section.offset().top - 100)
      }, 400);
		}
		
		// Update scroll button
		if($(selector.scrollBtn).length > 0) {
			this.initInfiniteScrollCollection(selector.products);
		}
	},

	resetPricesliders: function() {
		$.each(this.data.priceSlider, (index, slider) => {
			const sliderIns = $(slider);
			slider.noUiSlider.updateOptions({start:[sliderIns.attr('data-min'), sliderIns.attr('data-max')]}, true);
		});
	},

	initPriceSliders: function() {
		// Destroy old slider
		$.each(this.data.priceSlider, (index, slider) => {
			slider.noUiSlider.destroy();
		});
		this.data.priceSlider = [];
		$(this.selectors.filterPriceSlider).each((index, slider) => {
			const ele = $(slider);
			const cfContent = ele.parents(this.selectors.filterContent);
			const start = ele.attr('data-start')*1;
			const end = ele.attr('data-end')*1;
			const min = ele.attr('data-min')*1;
			const max = ele.attr('data-max')*1;
			noUiSlider.create(slider, {
		    connect: [false, true, false],
		    start: [start, end],
		    range: {
		        'min': min,
		        'max': max
		    },
		    step: 1,
		    format: {
		    	from: (value) => {
		    		return Math.round(value);
		    	},
		    	to: (value) => {
		    		return Math.round(value);
		    	}
		    },
		    direction: (rtl ? 'rtl' : 'ltr')
			});
			slider.noUiSlider.on('update', (values, handle, unencoded, tap, positions, noUiSlider) => {
				ele.parent().find(this.selectors.filterPriceFrom).html(BT.getPriceHtml(values[0]*100));
				ele.parent().find(this.selectors.filterPriceTo).html(BT.getPriceHtml(values[1]*100));
				ele.siblings(this.selectors.filterPriceInputMin).val(values[0]);
				ele.siblings(this.selectors.filterPriceInputMax).val(values[1]);
				BtCurrency.convertSilence(shopCurrency, BtCurrency.currentCurrency, '.cf__price span.money');
			});
			slider.noUiSlider.on('change', (values, handle, unencoded, tap, positions, noUiSlider) => {
				if(BT.data.cacheWindowWidth > BT.options.windowScreen.mobile) {
					this.submitFilterForm(ele);
				}
			});
			this.data.priceSlider.push(slider);
		});
	},

	addHistoryUrlToState: function(url, params) {
		if(this.inIframe()) {
			return;
		}
		try {
			let newUrl = url, newParams;
			if(params != undefined && params != null) {
				newParams = new URLSearchParams(params);	
			} else {
				newParams = new URLSearchParams(window.location.search)
			}
			
			newParams.delete('section_id');
			// newParams.delete('view');
			const newParamsStr = newParams.toString();
			if(newParamsStr != '') {
				if(url.indexOf('?') < 0) {
					newUrl += '?';
				} else {
					newUrl += '&';
				}
				newUrl += newParamsStr;
			}
			window.history.pushState({path: newUrl}, '', newUrl);	
		} catch (e) {
			console.log(e);
		}
	},

	inIframe: function() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
	},

	updateNewContent: function(url, params, updateHistory) {
		BT.showLoadingFull();
		BT.callAjax(url, 'GET', params, null, (html) => {
			this.updateHtml(html);
			this.initPriceSliders();
			BT.hideLoadingFull();

			if(url.indexOf('/search?') < 0) {
				this.data.collectionUrl = url.split('?')[0];	
			}
			if(updateHistory) {
				// Update history
				this.addHistoryUrlToState(url, params);
			}
		});
	},

	getSectionId: function(ele) {
		return ele.parents(this.selectors.section).first().attr('data-section-id');
	},
	submitFilterForm: function(ele) {
		ele.parents(this.selectors.filterForm).first().submit();
	},
	hideFilterCanvasOnMobile: function() {
		if(BT.data.cacheWindowWidth < 1200 && $('body').hasClass('open-sidebar-canvas--sidebar-filter')) {
			$('#sidebar-filter .bt-sidebar__close').trigger('click');
		}
	},
	updateTotalValuesNumber: function() {
		var total = parseInt($('.filter-action-mobile__item--submit-btn').attr('data-total-active-values'));
		if(total > 0) {
			$('.filter-active-number').removeClass('hide').text(total);
		} else {
			$('.filter-active-number').addClass('hide');
		}
	},
	initAjaxLinkEvent: function() {
		$(document).on(this.options.clickEvent, this.selectors.filterLink, (e) => {
			e.preventDefault();
			const link = $(e.currentTarget);
			const href = link.attr('href');
			const params = {section_id: this.getSectionId(link)};
			this.hideFilterCanvasOnMobile();
			this.updateNewContent(href, params, true);			
		});
		$(document).on('change', this.selectors.filterInput, (e) => {
			e.preventDefault();
			if(BT.data.cacheWindowWidth > BT.options.windowScreen.mobile) {
				this.submitFilterForm($(e.currentTarget));	
			}
		});
		$(document).on(this.options.clickEvent, this.selectors.sortLink, (e) => {
			e.preventDefault();
			$(this.selectors.sortInput).val($(e.currentTarget).attr('data-value'));
			this.submitFilterForm($(this.selectors.sortInput));
		});
		$(document).on('submit', this.selectors.filterForm, (e) => {
			e.preventDefault();
			this.hideFilterCanvasOnMobile();
			const formData = new FormData(e.target);
    	const searchParams = new URLSearchParams(formData).toString();
    	const sectionId = this.getSectionId($(e.currentTarget));
    	const url = window.location.pathname + '?' + searchParams;
    	this.updateNewContent(url, {'section_id': sectionId}, true);
		});
		$(document).on('click', this.selectors.filterApplyBtn, (e) => {
			e.preventDefault();
			$(this.selectors.filterForm).submit();
		});
		this.updateTotalValuesNumber();
	},

	initPopState: function() {
		this.addHistoryUrlToState(window.location.pathname);
		$(window).bind("popstate", (e) => {
	    const state = e.originalEvent.state;
	    if ( state !== null ) { 
	      this.updateNewContent(state.path, {}, false);
	    }

		});
	},

	destroyInfiniteScroll: function() {
		BT.destroyInfiniteScroll('collection-template');
	},

	initInfiniteScrollCollection: function(wrap) {
		this.destroyInfiniteScroll();
		BT.initInfiniteScroll(wrap);
	},

	openCurrentFilterDropdown: function() {
		$('.cfc__link.active').each((index, linkEle) => {
			const link = $(linkEle);
			link.parents('.cfc__dropdown').each((indexDropdown, dropdownEle) => {
				const dropdown = $(dropdownEle);
				dropdown.show();
				dropdown.parent('.link-list__item').addClass('open');
			});
		});
	},

	init: function() {
		this.initAjaxLinkEvent();
		BT.initExpandTrigger();
		this.initPopState();
		$(document).on('click', '.close-filter-btn', (e) => {
			e.preventDefault();
			$('#sidebar-filter .bt-sidebar__close').trigger('click');
		});
	}
}

class CollectionTemplateSection extends BTSection {
	onInit() {
		BTCollection.data.collectionUrl = this.container.attr('data-url');
  	BtCurrency.convertSilence(shopCurrency, BtCurrency.currentCurrency, this.container.find('span.money'));
    BTCollection.initInfiniteScrollCollection(this.container);
    BT.initDealCountdown(this.container.find(BTCollection.selectors.products));
    BTCollection.initPriceSliders();
    BTCollection.applyCustomColorSwatches(this.container);
  }

	onUnload() {
    BTCollection.destroyInfiniteScroll();
  }
}

BTCollection.init();
theme.sections.constructors['collection-template'] = CollectionTemplateSection;